<div id="card-items" class=" pb-5 mb-[2rem]">
    <div class="container px-5 ">
        <h2 class=" mb-5 font-bold text-2xl text-[#010128] md:text-4xl text-center">How to Use Exam Questions</h2>
        <h3 class="mb-[5rem] text-center text-[18px]">Want to make your revision more effective and boost your exam
            results? Follow these
            three simple steps to get the most out of our expertly designed questions.</h3>
        <div class="flex flex-wrap justify-center ">
            @for (item of cardItems; track $index) {
            <div class="w-full md:w-1/2 lg:w-1/3 px-4 mb-6 h-auto ">

                <app-card-item [cardItem]="item" />
            </div>
            }
        </div>


    </div>